import SchemaGeneratorLight from './schema-generator-light'
import SchemaGeneratorDark from './schema-generator-dark'

export {
  SchemaGeneratorLight,
  SchemaGeneratorDark,
}
